import { ComponenteCarregandoPagina } from "./styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import LoadingSRC from "../../assets/jsons/Loading.json";
import { Player, Controls } from "@lottiefiles/react-lottie-player";

interface LoadingProps {
  relative?: boolean;
}
const Loading: React.FC<LoadingProps> = ({ relative = false }) => {
  const animation = LoadingSRC;

  const { theme } = useTheme();

  return (
    <>
      <ComponenteCarregandoPagina theme={theme} relative={relative}>
        <div className="loading-container">
          <div
            className="componente-carregando-pagina"
          >
            <Player
              autoplay
              loop
              src={animation}
              style={{ height: "80px", width: "80px" }}
            >
              <Controls
                visible={false}
                buttons={["play", "repeat", "frame", "debug"]}
              />
            </Player>
          </div>
        </div>
      </ComponenteCarregandoPagina>
    </>
  );
};

export default Loading;
